import { render, staticRenderFns } from "./ProductsComparison.vue?vue&type=template&id=14f8a1eb&"
import script from "./ProductsComparison.vue?vue&type=script&lang=js&"
export * from "./ProductsComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports